export default {
  "pdf.sendEmail": "メール",
  "pdf.pdf": "PDF",
  "pdf.print": "印刷",
  "pdf.zipCode": "〒",
  "pdf.invoiceInside": "請 求 書 在 中", //leave blank space, in order to fix Safari PDF UI issues.
  "pdf.negotiatorStamp": "支配人印",
  "pdf.seal": "担当印",
  "pdf.invoiceDate": "請求日：",
  "pdf.paymentDeadline": "お支払期限：",
  "pdf.invoiceNumber": "請求書番号：",
  "pdf.invoice": "請求書",
  "pdf.subject": "件名：",
  "pdf.billAmount": "ご請求金額",
  "pdf.yen": "円",
  "pdf.tel": "TEL:",
  "pdf.fax": "FAX:",
  "pdf.companyStamp": "会社印",
  "pdf.commodity": "品目",
  "pdf.Feesetc": "手数料等",
  "pdf.FeesRate": "手数料率",

  "pdf.ticketSale.title": "シネ・リーブル池袋",
  "pdf.ticketSale.subTitle": "売上報告",
  "pdf.ticketSale.tableName": "興収売上内訳表",
  "pdf.shopSale.tableName": "付帯売上内訳表",
  "pdf.ticketSale.project": "項目",
  "pdf.ticketSale.item": "項番",
  "pdf.ticketSale.summary": "摘要",
  "pdf.ticketSale.taxOutAmount": "金額（税抜）",
  "pdf.ticketSale.saleTax": "消費税",
  "pdf.ticketSale.taxAmount": "金額（税込）",

  "pdf.ticketSale.dailyPayment": "日付",
  "pdf.ticketSale.saleDate": "売上日付",
  "pdf.ticketSale.cinemaNameRow": "店舗名",
  "pdf.ticketSale.cinemaName": "店舗名称",
  "pdf.ticketSale.salesRecord": "売上記録",
  "pdf.ticketSale.controlDeduction": "控除額",

  "pdf.ticketSale.key.goldSale": "現金売",
  "pdf.ticketSale.key.hang": "掛売",
  "pdf.ticketSale.key.creditSale": "クレジット売",
  "pdf.ticketSale.key.commodityCoupons": "商品券売",
  "pdf.ticketSale.key.couponFishing": "商品券釣り",
  "pdf.ticketSale.key.electronicSales": "電子マネー売",
  "pdf.ticketSale.key.totalSale": "総売上高",
  "pdf.ticketSale.key.tax": "税金",
  "pdf.ticketSale.key.excludedProducts": "売上除外品",
  "pdf.ticketSale.key.controlDeduction": "控除額計",
  "pdf.ticketSale.key.netSalesHigh": "純売上高",
  "pdf.ticketSale.key.cashInHigh(naive)": "現金在高（ 納 金 ）",
  "pdf.ticketSale.key.customerNumber": "客数",
  "pdf.ticketSale.key.returnedGoods": "戻し・返品",



  "pdf.ticketSale.value.goldSale": "現金売上（税金・売上除外品含む）",
  "pdf.ticketSale.value.hang": "前売券（当館以外での販売）の着券売上",
  "pdf.ticketSale.value.creditSale": "貴社一括契約のクレジット売上",
  "pdf.ticketSale.value.commodityCoupons": "貴社一括契約の商品券類の売上",
  "pdf.ticketSale.value.couponFishing": "商品券販売時の釣銭",
  "pdf.ticketSale.value.electronicSales": "貴社一括契約の電子マネー売上",
  "pdf.ticketSale.value.tax": "総売上高(消費税)-売上除外品(消費税)",
  "pdf.ticketSale.value.excludedProducts": "カード入会金",
  "pdf.ticketSale.value.netSalesHigh": "総売上高(金額（税込）)-控除額計(金額（税込）)",
  "pdf.ticketSale.value.customerNumber": "レジ客数",
  "pdf.ticketSale.value.returnedGoods": "レジマイナス分",

  "pdf.ticketSale.liquidationReport.title": "売上報告リスト",
  "pdf.ticketSale.liquidationReport.subTitle": "（清算報告）",
  "pdf.ticketSale.liquidationReport.businessDay": "営業日",
  "pdf.ticketSale.liquidationReport.storeCode": "店舗コード",
  "pdf.ticketSale.liquidationReport.hanging": "掛・自社券等",
  "pdf.ticketSale.liquidationReport.creditSales": "クレジット売上",
  "pdf.ticketSale.liquidationReport.coupon": "商品券売上",
  "pdf.ticketSale.liquidationReport.cash": "現金売上",
  "pdf.ticketSale.liquidationReport.electronicSales": "電子マネー売上",
  "pdf.ticketSale.liquidationReport.totalSale": "総売上合計",
  "pdf.ticketSale.liquidationReport.specialTax": "特別地方消費税",
  "pdf.ticketSale.liquidationReport.disposal": "売上控除",
  "pdf.ticketSale.liquidationReport.controlTotal": "控除合計",
  "pdf.ticketSale.liquidationReport.pureSales": "純売上",
  "pdf.ticketSale.liquidationReport.cashInHigh": "現金在高",
};